import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { UtilService } from '../../components/common/utils/util.service';
import { SessionTokenService } from '../../components/common/utils/sessionToken.service';
import { HandleError } from '../../components/common/utils/handleError.component';
import { ClienteLogin, Cliente, ClienteXCiudad,ClienteResumen } from '../login/cliente_login';
import { UsuarioLoginEntity } from '../login/usuario_login_entity';
import { ConsultarUsuarioMasivos } from '../../components/common/utils/consultarUsuarioMasivos';
import { DatosGeneralesService } from '../masivos/datosGenerales/datos-generales.service';
import { ClienteIndividualEntity } from '../masivos/datosGenerales/entities/datos_generales_individual_entity';
import { SiniestroscorporativoService } from './siniestroscorporativo.service';
import { Siniestros, VehiculoSiniestros, O2O, CasaHabitacion, OtrosRamos } from '../../components/common/siniestros_entity';
import { ResultadoMovmientosPorPlan } from '../empresas/entities/vam_entities';
import { MensajeCampoValor } from './siniestroscorporativos_entity';

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'siniestroscorporativos',
    templateUrl: 'siniestroscorporativos.template.html'
})
export class SiniestroscorporarivoComponent implements OnInit {
    usuario: ClienteLogin;
    usuarioLogin: UsuarioLoginEntity;
    usuariocorporativo: ClienteResumen;
    userAUsar: Cliente;
    clienteMasivosIndividual: ClienteIndividualEntity;
    banderaMasivos: boolean;
    siniestro: Siniestros;
    showLoader: string;
    userEmpresa: ClienteXCiudad;
    placas: string[];
    estadosVeh: string[];
    direcciones: string[];
    estadosCas: string[];
    pacientes: string[];
    diagnosticos: string[];
    estadosO2O: string[];
    bienesAfectados: string[];
    tiposReclamoOtroRamo: string[];
    estadosOtrosRamos: string[];
    filterQuery: string = "";
    filterQuery1: string = "";
    filterQuery2: string = "";
    filterQuery3: string = "";
    filterQuery4: string = "";
    filterQuery5: string = "";
    filterQuery6: string = "";
    filterQuery7: string = "";
    filterQuery8: string = "";
    filterQuery9: string = "";

    trackVehiculo: object;
    rcDeducible: MensajeCampoValor[] = new Array<MensajeCampoValor>();
    banderaTrackingVehiculo: boolean = false;
    trackVivienda: object;
    banderaTrackingVivienda: boolean = false;
    trackO2O: object;
    banderaTrackingO2O: boolean = false;
    trackOtrosRamos: object;
    banderaTrackingOtrosRamos: boolean = false;

    codUniVeh: number = 0;

    @ViewChild('wrap') wrap: ElementRef;

    veh: boolean = false;
    cas: boolean = false;
    asi: boolean = false;
    otr: boolean = false;

    showLoaderVeh: string = "";
    showLoaderViv: string = "";
    showLoaderO2O: string = "";
    showLoaderOtrRamos: string = "";

    constructor(
        public utilsService: UtilService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private sesionStorageService: SessionStorageService,
        private consultarMasivo: ConsultarUsuarioMasivos,
        private datosGeneralesIndividualSevice: DatosGeneralesService,
        private siniestrosService: SiniestroscorporativoService) {
        this.banderaMasivos = false;
        this.placas = new Array<string>();
        this.estadosVeh = new Array<string>();
        this.direcciones = new Array<string>();
        this.estadosCas = new Array<string>();
        this.pacientes = new Array<string>();
        this.diagnosticos = new Array<string>();
        this.estadosO2O = new Array<string>();
        this.bienesAfectados = new Array<string>();
        this.tiposReclamoOtroRamo = new Array<string>();
        this.estadosOtrosRamos = new Array<string>();
        this.trackVehiculo = new Object();
        this.usuariocorporativo=new ClienteResumen();
    }

    ngOnInit() {
        this.usuarioLogin = JSON.parse(this.sesionStorageService.retrieve("usuariologin"));
       {
            this.banderaMasivos = false;
            try {
                this.showLoader = "sk-loading";
                this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
                this.sesionStorageService.observe("usuario").subscribe(a => {
                    try {
                        this.usuario = jQuery.parseJSON(a);
                        this.CargarDatos();
                    } catch (ex) {
                        this.usuario = a;
                        this.CargarDatos();
                    }
                })
            } catch (ex) {

            }
        }
        this.CargarDatos();
    }
    CargarDatos() {
        this.siniestro = new Siniestros();
        let cliente = new Cliente();
         {
            if (this.usuario == null) {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            } else {
                let bandera = this.sessionTokenService.useJwtHelper();
                if (!bandera) {
                    try {
                        
                        this.usuariocorporativo=jQuery.parseJSON(this.sesionStorageService.retrieve("usercorporativo"));
                        if(this.usuariocorporativo==null || this.usuariocorporativo==undefined){
                            this.usuariocorporativo=this.usuario.Corporativo[0];
                        }
                        console.log(this.usuariocorporativo);
                        cliente.Ciudad = this.usuariocorporativo.Ciudad;
                        cliente.CodigoCliente = this.usuariocorporativo.Codigocliente;
                    } catch (e) {
                        this.userEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                        cliente.Ciudad = this.userEmpresa.Ciudad;
                        cliente.CodigoCliente = this.userEmpresa.CodigoCliente;
                    }
                }
                cliente.TipoCliente = 1;
            }
        }
        this.siniestrosService.ConsultarSiniestros(this.usuariocorporativo).subscribe(
            result => {
                this.siniestro = result;
                this.showTable();
                this.siniestro.Vehiculos.forEach(a => {
                    this.placas.push(a.Placa);
                    this.estadosVeh.push(a.Estado);
                });
                this.placas = this.placas.filter((x, i, a) => x && a.indexOf(x) === i);
                this.estadosVeh = this.estadosVeh.filter((x, i, a) => x && a.indexOf(x) === i);
               

                this.showLoader = "";
            },
            error => {
                this.showLoader = "";
                this.handleError.redirectUrl(error);
            }
        );
    }
    cargarSiniestro(siniestroConsulta: VehiculoSiniestros) {
        this.showLoaderVeh = "sk-loading";
        this.banderaTrackingVehiculo = false;
        this.siniestrosService.ConsultaTrackingVehiculos(siniestroConsulta.CodUnicoSiniestro).subscribe(
            result => {
                this.trackVehiculo = result;
                this.codUniVeh = siniestroConsulta.CodUnicoSiniestro;
                this.banderaTrackingVehiculo = true;
                /*this.siniestrosService.DetalleRcsYDeducible(siniestroConsulta.CodUnicoSiniestro).subscribe(
                    resultRcsDeducible => {
                        this.rcDeducible = resultRcsDeducible;
                    },
                    error => {
                        this.showLoaderVeh = "";
                        this.banderaTrackingVehiculo = false;
                        this.handleError.redirectUrl(error);
                    }
                );*/
                this.showLoaderVeh = "";
                setTimeout(() => {
                    window.scrollBy(0, this.wrap.nativeElement.offsetHeight);
                }, 300);
            },
            error => {
                this.showLoaderVeh = "";
                this.banderaTrackingVehiculo = false;
                this.handleError.redirectUrl(error);
            }
        );
    }

    showTable() {
        if (this.siniestro.Vehiculos != null && this.siniestro.Vehiculos != undefined && this.siniestro.Vehiculos.length > 0) {
            if (this.siniestro.CasaHabitacion != null && this.siniestro.CasaHabitacion != undefined && this.siniestro.CasaHabitacion.length > 0) {
                if (this.siniestro.O2O != null && this.siniestro.O2O != undefined && this.siniestro.O2O.length > 0) {
                    if (this.siniestro.OtrosRamos != null && this.siniestro.OtrosRamos != undefined && this.siniestro.OtrosRamos.length > 0) {
                        this.veh = true;
                        this.cas = false;
                        this.asi = false;
                        this.otr = false;
                    } else {
                        this.veh = true;
                        this.cas = false;
                        this.asi = false;
                        this.otr = false;
                    }
                } else {
                    if (this.siniestro.OtrosRamos != null && this.siniestro.OtrosRamos != undefined && this.siniestro.OtrosRamos.length > 0) {
                        this.veh = true;
                        this.cas = false;
                        this.asi = false;
                        this.otr = false;
                    } else {
                        this.veh = true;
                        this.cas = false;
                        this.asi = false;
                        this.otr = false;
                    }
                }
            } else {
                if (this.siniestro.O2O != null && this.siniestro.O2O != undefined && this.siniestro.O2O.length > 0) {
                    if (this.siniestro.OtrosRamos != null && this.siniestro.OtrosRamos != undefined && this.siniestro.OtrosRamos.length > 0) {
                        this.veh = true;
                        this.cas = false;
                        this.asi = false;
                        this.otr = false;
                    } else {
                        this.veh = true;
                        this.cas = false;
                        this.asi = false;
                        this.otr = false;
                    }
                } else {
                    if (this.siniestro.OtrosRamos != null && this.siniestro.OtrosRamos != undefined && this.siniestro.OtrosRamos.length > 0) {
                        this.veh = true;
                        this.cas = false;
                        this.asi = false;
                        this.otr = false;
                    } else {
                        this.veh = true;
                        this.cas = false;
                        this.asi = false;
                        this.otr = false;
                    }
                }
            }
        } else {
            if (this.siniestro.CasaHabitacion != null && this.siniestro.CasaHabitacion != undefined && this.siniestro.CasaHabitacion.length > 0) {
                if (this.siniestro.O2O != null && this.siniestro.O2O != undefined && this.siniestro.O2O.length > 0) {
                    if (this.siniestro.OtrosRamos != null && this.siniestro.OtrosRamos != undefined && this.siniestro.OtrosRamos.length > 0) {
                        this.veh = false;
                        this.cas = true;
                        this.asi = false;
                        this.otr = false;
                    } else {
                        this.veh = false;
                        this.cas = true;
                        this.asi = false;
                        this.otr = false;
                    }
                } else {
                    if (this.siniestro.OtrosRamos != null && this.siniestro.OtrosRamos != undefined && this.siniestro.OtrosRamos.length > 0) {
                        this.veh = false;
                        this.cas = true;
                        this.asi = false;
                        this.otr = false;
                    } else {
                        this.veh = false;
                        this.cas = true;
                        this.asi = false;
                        this.otr = false;
                    }
                }
            } else {
                if (this.siniestro.O2O != null && this.siniestro.O2O != undefined && this.siniestro.O2O.length > 0) {
                    if (this.siniestro.OtrosRamos != null && this.siniestro.OtrosRamos != undefined && this.siniestro.OtrosRamos.length > 0) {
                        this.veh = false;
                        this.cas = false;
                        this.asi = true;
                        this.otr = false;
                    } else {
                        this.veh = false;
                        this.cas = false;
                        this.asi = true;
                        this.otr = false;
                    }
                } else {
                    if (this.siniestro.OtrosRamos != null && this.siniestro.OtrosRamos != undefined && this.siniestro.OtrosRamos.length > 0) {
                        this.veh = false;
                        this.cas = false;
                        this.asi = false;
                        this.otr = true;
                    } else {
                        this.veh = false;
                        this.cas = false;
                        this.asi = false;
                        this.otr = false;
                    }
                }
            }
        }
    }

    cargarSiniestroO2O(siniestroConsulta: O2O) {
        this.showLoaderO2O = "sk-loading";
        this.banderaTrackingO2O = false;
        this.siniestrosService.ConsultaTrackingAsistencia(siniestroConsulta.CodUnicoSiniestro).subscribe(
            result => {
                this.trackO2O = result;
                this.banderaTrackingO2O = true;
                this.showLoaderO2O = "";
                setTimeout(() => {
                    window.scrollBy(0, this.wrap.nativeElement.offsetHeight);
                }, 300);
            },
            error => {
                this.showLoaderO2O = "";
                this.banderaTrackingO2O = false;
                this.handleError.redirectUrl(error);
            }
        );
    }
    cargarSiniestroVivienda(siniestroConsulta: CasaHabitacion) {
        this.showLoaderViv = "sk-loading";
        this.banderaTrackingVivienda = false;
        this.siniestrosService.ConsultaTrackingOtrosRamos(siniestroConsulta.CodUnicoSiniestro).subscribe(
            result => {
                this.trackVivienda = result;
                this.banderaTrackingVivienda = true;
                this.showLoaderViv = "";
                setTimeout(() => {
                    window.scrollBy(0, this.wrap.nativeElement.offsetHeight);
                }, 300);
            },
            error => {
                this.showLoaderViv = "";
                this.banderaTrackingVivienda = false;
                this.handleError.redirectUrl(error);
            }
        );
    }
    cargarSiniestroOtrosRamos(siniestroConsulta: OtrosRamos) {
        this.showLoaderOtrRamos = "sk-loading";
        this.banderaTrackingOtrosRamos = false;
        this.siniestrosService.ConsultaTrackingOtrosRamos(siniestroConsulta.CodUnicoSiniestro).subscribe(
            result => {
                this.trackOtrosRamos = result;
                this.banderaTrackingOtrosRamos = true;
                this.showLoaderOtrRamos = "";
                setTimeout(() => {
                    window.scrollBy(0, this.wrap.nativeElement.offsetHeight);
                }, 300);
            },
            error => {
                this.showLoaderOtrRamos = "";
                this.banderaTrackingOtrosRamos = false;
                this.handleError.redirectUrl(error);
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestroscorporativos/siniestroscorporativos.component.ts